import { render, staticRenderFns } from "./Organiser.vue?vue&type=template&id=940de8c4"
import script from "./Organiser.vue?vue&type=script&lang=js"
export * from "./Organiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports